import React from "react";
import TimeAgo from "react-timeago";
import { cleanDate } from "../../../../util/app";

function BodyMapList({ items = [], onView }) {
    if (!items.length)
        return (
            <div className="text-center">
                <h4 className="text-pink">No Body Map has been recorded yet!</h4>
            </div>
        );
    return (
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th scope="col" className="text-center">
                        SN
                    </th>
                    <th scope="col">Date & Time</th>
                    <th scope="col">Injury Type</th>
                    <th scope="col">Description</th>
                    <th className="text-center">View/Download</th>
                </tr>
            </thead>
            <tbody>
                {items.map((item, index) => (
                    <tr key={index}>
                        <td className="inbox-small-cells">
                            <strong className="text-center">{index + 1}</strong>
                        </td>

                        <td className="view-message">
                            <strong>{cleanDate(item.created_at, true)}</strong>{" "}
                            <span className="badge badge-primary">
                                {Intl.DateTimeFormat("en-GB", {
                                    hour12: true,
                                    minute: "numeric",
                                    hour: "numeric",
                                    second: "numeric"
                                }).format(new Date(item.created_at))}
                            </span>
                            <p className="text-muted">
                                <TimeAgo date={item.created_at} />
                            </p>
                        </td>

                        <td className="view-message">
                            <strong>{item.injuryType}</strong>
                        </td>
                        <td className="view-message">{item.description}</td>

                        <td className="view-message text-center">
                            <button type="button" onClick={() => onView(item)} title="View" className="mdl-button margin-right-10 mdl-button--icon mdl-button--colored btn-default">
                                <i className="material-icons text-primary">arrow_right_alt</i>
                            </button>
                            <button
                                type="button"
                                onClick={() => {
                                    document.location.href = item.photo;
                                }}
                                title="Download"
                                className="mdl-button margin-left-10 mdl-button--icon mdl-button--colored btn-default"
                            >
                                <i className="material-icons text-primary">cloud_download</i>
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default BodyMapList;
